module.exports = __webpack_public_path__ + "static/media/GA_wordmark_novare_Black-1.154ed636.svg";